import { call, put, takeLatest } from 'redux-saga/effects';
import backupLogsService from '../../../services/backupLogsService';
import {
  fetchBackupLogs,
  fetchBackupLogsSuccess,
  fetchBackupLogsFailure,
  deleteBackupLog,
  deleteBackupLogSuccess,
  deleteBackupLogFailure,
  bulkDeleteBackupLogs,
  bulkDeleteBackupLogsSuccess,
  bulkDeleteBackupLogsFailure,
} from './slice';

function* handleFetchBackupLogs(action) {
  try {
    const response = yield call(backupLogsService.getBackupLogs, action.payload);
    yield put(fetchBackupLogsSuccess(response));
  } catch (error) {
    yield put(fetchBackupLogsFailure(error.message));
  }
}

function* handleDeleteBackupLog(action) {
  try {
    const id = action.payload;
    yield call(backupLogsService.deleteBackupLog, id);
    yield put(deleteBackupLogSuccess(id));
  } catch (error) {
    yield put(deleteBackupLogFailure(error.message));
  }
}

function* handleBulkDeleteBackupLogs(action) {
  try {
    const ids = action.payload;
    yield call(backupLogsService.bulkDeleteBackupLogs, ids);
    yield put(bulkDeleteBackupLogsSuccess(ids));
  } catch (error) {
    yield put(bulkDeleteBackupLogsFailure(error.message));
  }
}

export function* watchBackupLogsActions() {
  yield takeLatest(fetchBackupLogs.type, handleFetchBackupLogs);
  yield takeLatest(deleteBackupLog.type, handleDeleteBackupLog);
  yield takeLatest(bulkDeleteBackupLogs.type, handleBulkDeleteBackupLogs);
}
